const isIe11 = function isIE11() {
  const ieVersion = document.body.style.msTouchAction !== undefined;
  return ieVersion;
};

export default isIe11;
